const GraduationCapIcon = ({ fill = '#E4F8ED', width = '16', height = '16' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 3L2 8L12 13L20 8.94V15H21.5V8L12 3Z"
        fill={fill}
      />
      <path
        d="M6 10.6V15.2C6 16.7464 8.68629 18 12 18C15.3137 18 18 16.7464 18 15.2V10.6L12 13.6L6 10.6Z"
        fill={fill}
        opacity="0.85"
      />
    </svg>
  )
}

export default GraduationCapIcon
